export default __webpack_public_path__ + "static/media/property_614.260de8b1.png";